import { render, staticRenderFns } from "./SecuritiesDigitalService.vue?vue&type=template&id=661a3fec"
import script from "./SecuritiesDigitalService.vue?vue&type=script&lang=js"
export * from "./SecuritiesDigitalService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports